import {
    FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST,
    FETCH_ADMIN_ORGANIZATIONS_LIST_SUCCESS,
    FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL,
    OrganizationsActionTypes,
    FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST,
    FETCH_MEMBER_ORGANIZATIONS_LIST_SUCCESS,
} from './types';

export const fetchAdminOrganizationsList = (): OrganizationsActionTypes => ({
    type: FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST,
});

export const fetchAdminOrganizationsListSuccess = (data = []): OrganizationsActionTypes => ({
    type: FETCH_ADMIN_ORGANIZATIONS_LIST_SUCCESS,
    payload: { data },
});

export const fetchAdminOrganizationsListError = (): OrganizationsActionTypes => ({
    type: FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL,
});

export const fetchMemberOrganizationsList = (): OrganizationsActionTypes => ({
    type: FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST,
});

export const fetchMemberOrganizationsListSuccess = (data = []): OrganizationsActionTypes => ({
    type: FETCH_MEMBER_ORGANIZATIONS_LIST_SUCCESS,
    payload: { data },
});

export const fetchMemberOrganizationsListError = (): OrganizationsActionTypes => ({
    type: FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL,
});
